import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form layout-column p-md sm:p-0 gap-xl w-full sm:w-[343px] md:w-[352px]" };
const _hoisted_2 = { class: "layout-column gap-md items-center md:items-stretch" };
const _hoisted_3 = { class: "typography-display-small dark:text-on-background-dark" };
const _hoisted_4 = { class: "layout-column gap-md" };
const _hoisted_5 = { class: "layout-row justify-between gap-md" };
const _hoisted_6 = { class: "layout-column gap-md" };
import { OrButtonV3, OrCheckboxV3, OrInputV3, OrNotificationV3 } from '@onereach/ui-components';
import { ref } from 'vue';
import OrSubtitles from '@/components/OrLoginSubtitles/OrSubtitles.vue';
import OrLogo from '@/components/OrLogo/OrLogo.vue';
import useI18n from '@/composables/useI18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    props: {
        serviceError: {},
        password: {},
        username: {},
        readonlyLogin: { type: Boolean },
        keepLoggedIn: { type: Boolean },
        isLoading: { type: Boolean },
        externalProviders: { default: () => [] }
    },
    emits: ["submit", "initExternalLogin", "showForgotPopup", "update:username", "update:password", "update:keepLoggedIn"],
    setup(__props, { emit: __emit }) {
        const { translate } = useI18n();
        const props = __props;
        const emit = __emit;
        const updateEmail = (value) => {
            const trimmed = value === undefined ? value : value.trim();
            emit('update:username', trimmed);
            return trimmed;
        };
        const emailError = ref('');
        const passwordError = ref('');
        const submit = () => {
            emailError.value = !props.username ? translate('login.password_restore.This field is required') : '';
            if (emailError.value)
                return;
            passwordError.value = !props.password ? translate('login.password_restore.This field is required') : '';
            if (passwordError.value)
                return;
            emit('submit');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OrLogo, { class: "self-center md:hidden mb-md" }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translate)('login.login.signInToOnereachai')), 1),
                    _createVNode(OrSubtitles)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_ctx.serviceError)
                        ? (_openBlock(), _createBlock(_unref(OrNotificationV3), {
                            key: 0,
                            class: "error",
                            variant: "error",
                            "disable-close": ""
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.serviceError), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(OrInputV3), {
                        "model-value": _ctx.username,
                        "data-test": "username",
                        class: "username",
                        name: "username",
                        type: "text",
                        readonly: _ctx.readonlyLogin,
                        error: emailError.value || !!_ctx.serviceError,
                        label: _unref(translate)('login.login.emailAddress'),
                        placeholder: _unref(translate)('login.login.Enter email'),
                        disabled: _ctx.isLoading,
                        "onUpdate:modelValue": updateEmail,
                        onKeyup: _withKeys(submit, ["enter", "native"])
                    }, null, 8, ["model-value", "readonly", "error", "label", "placeholder", "disabled"]),
                    _createVNode(_unref(OrInputV3), {
                        "model-value": _ctx.password,
                        class: "password",
                        "data-test": "password",
                        type: "password",
                        error: passwordError.value || !!_ctx.serviceError,
                        label: _unref(translate)('login.login.password'),
                        disabled: _ctx.isLoading,
                        placeholder: _unref(translate)('login.login.Enter password'),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:password', $event))),
                        onKeyup: _withKeys(submit, ["enter", "native"])
                    }, null, 8, ["model-value", "error", "label", "disabled", "placeholder"]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(OrCheckboxV3), {
                            "model-value": _ctx.keepLoggedIn,
                            "data-test": "keepLoggedIn",
                            class: "form-checkbox grey",
                            disabled: _ctx.isLoading,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:keepLoggedIn', $event))),
                            onKeyup: _withKeys(submit, ["enter", "native"])
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)('login.login.Keep me signed in')), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "disabled"]),
                        _createVNode(_unref(OrButtonV3), {
                            variant: "text",
                            class: "!p-0",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (emit('showForgotPopup')), ["prevent"]))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)('login.login.forgotPassword')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _renderSlot(_ctx.$slots, "captcha"),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(OrButtonV3), {
                        "data-test": "submit",
                        loading: _ctx.isLoading,
                        class: "sign-in",
                        type: "submit",
                        onClick: submit
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)('login.login.signIn')), 1)
                        ]),
                        _: 1
                    }, 8, ["loading"]),
                    _renderSlot(_ctx.$slots, "google-login"),
                    _renderSlot(_ctx.$slots, "external-providers")
                ])
            ]));
        };
    }
});
